import { Route, Routes, Navigate, useParams } from "react-router-dom";
import About from "./Pages/about/About";
import IndustriesWeServe from "./Pages/industries/IndustriesWeServe";
import IsoCertificationServices from "./Pages/iso-certification-services/IsoCertificationServices";
import FoodSafetyServices from "./Pages/food-safety-services/FoodSafetyServices";
import SustainabilityEsgServices from "./Pages/sustainability-esg-services/SustainabilityEsgServices";
import TextileComplianceServices from "./Pages/textile-compliance-services/TextileComplianceServices";
import SupplyChainCertificationServices from "./Pages/supply-chain-certification-services/SupplyChainCertificationServices";
import ServiceCategoryPage from "./Pages/iso-lead-auditor/ServiceCategoryPage";
import { CATEGORY_ORDER, categoryToId } from "./Pages/iso-lead-auditor/isoLeadAuditorData";
import Services from "./Pages/Services/Services";
import Pecb from "./Pages/pecb/Pecb";
import Team from "./Pages/team/Team";
import Trainings from "./Pages/trainings/Trainings";
import HighfieldTraining from "./Pages/trainings/HighfieldTraining";
import HaccpTraining from "./Pages/trainings/HaccpTraining";
import PecbTraining from "./Pages/trainings/PecbTraining";
import CorporateTraining from "./Pages/trainings/CorporateTraining";
import IoshManagingSafelyTraining from "./Pages/trainings/IoshManagingSafelyTraining";
import SafetyTraining from "./Pages/trainings/SafetyTraining";
import Contact from "./Pages/contact/Contact";
import Jobs from "./Pages/jobs/Jobs";
import Certification from "./Pages/Services/Certification/Certification";
import Auditing from "./Pages/Services/Auditing/Audidting";
import SkillBuilding from "./Pages/Services/Skill Building/SkillBuilding";
import WhatsAppLogo from "./WhatsappLogo/WhatsAppLogo";
import MainHome from "./Pages/Home/MainHome";
import { lazy, Suspense, useEffect, useState } from "react";
import { BsChevronUp } from "react-icons/bs";
import ServicePage2 from "./Pages/IndustrialCoverage/ServiceInnerPage";
import Login from "./ServerSide/Login";
import Downloads from "./Pages/downloads/Downloads";
import PageNotFound from "./Pages/PageNotFound";
import Cookies from "./components/Cookies";
import Tracking from "./Pages/tracking/Tracking";
import AdminBlogUpdate from "./ServerSide/Blogs/AdminBlogUpdate";
import { useCookies } from "react-cookie";
import Dashboard from "./ServerSide/Dashoard/Dashboard";
import UpdateTeam from "./ServerSide/Team/UpdateTeam";
import UpdateClient from "./ServerSide/Client/UpdateClient";
import Clientele from "./Pages/Clientele/Clientele";
import TermsAndConditions from "./Pages/TermsConditition/TermsAndConditions";
import UpdatePosting from "./ServerSide/JobsPosting/UpdatePosting";
import TrainingDetails from "./Pages/trainings/TrainingDetails";
import RegisterForm from "./Pages/trainings/RegisterForm";
import AOS from 'aos';
import 'aos/dist/aos.css';
import Faq from "./Pages/faq/Faq";
import Careers from "./Pages/careers/Careers";
import IsoLeadAuditorTraining from "./Pages/iso-lead-auditor/IsoLeadAuditorTraining";
import IsoLeadAuditorDetail from "./Pages/iso-lead-auditor/IsoLeadAuditorDetail";




/* The blog carries the full Blog Strategy article set, so it is split into
   its own chunk and only downloaded when a /blog route is opened. */
const Blog = lazy(() => import("./Pages/blog/Blog"));
const BlogCategoryPage = lazy(() => import("./Pages/blog/BlogCategoryPage"));
const BlogPostRoute = lazy(() => import("./Pages/blog/BlogPostRoute"));

const withSuspense = (element) => (
  <Suspense
    fallback={
      <div className="flex h-[60vh] items-center justify-center">
        <span className="loader" aria-label="Loading" />
      </div>
    }
  >
    {element}
  </Suspense>
);

function App() {

  const [showScrollTop, setShowScrollTop] = useState(false);
  const { specificBlogId } = useParams();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };


  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => { }, [specificBlogId]);
  const [cookies] = useCookies(["clickedServiceId"]);

  const user = localStorage.getItem("token");
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  return (
    <>
      {showScrollTop && (
        <div
          className="fixed bottom-8  z-[1000] hover:shadow-lg text-white  hover:scale-100 right-8 cursor-pointer bg-orange-600 transition-all ease-out duration-300 p-2 hover:bg-purple-700 shadow-md "
          onClick={scrollToTop}
        >
          <BsChevronUp size={22} className="" />
        </div>
      )}
      <WhatsAppLogo />
      <Cookies />
      <Routes>
        <Route path="/" element={<MainHome />} />

        <Route path="/index.php" element={<MainHome />} />
        <Route path="*" element={<PageNotFound />} />
        <Route path="/our_team.php" element={<Team />} />
        {user && <Route exact path="/admindashboard" element={<Dashboard />} />}
        {user && (
          <Route
            path="/adminlogin"
            element={<Navigate replace to="/admindashboard" />}
          />
        )}
        {user && (
          <Route exact path="/updateblog" element={<AdminBlogUpdate />} />
        )}
        {!user && (
          <Route
            path="/updateblog"
            element={<Navigate replace to="/adminologin" />}
          />
        )}

        {!user && (
          <Route
            exact
            path="/admindashboard"
            element={<Navigate replace to="/adminlogin" />}
          />
        )}
        {user && <Route path="/updateteam" element={<UpdateTeam />} />}

        {!user && (
          <Route
            exact
            path="/updateteam"
            element={<Navigate replace to="/adminlogin" />}
          />
        )}
        {user && <Route path="/updateposting" element={<UpdatePosting />} />}

        {!user && (
          <Route
            exact
            path="/updateposting"
            element={<Navigate replace to="/adminlogin" />}
          />
        )}

        {!user && <Route exact path="/adminlogin" element={<Login />} />}

        <Route path="/jobs" element={<Jobs />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/downloads" element={<Downloads />} />
        <Route path="/about" element={<About />} />
        <Route
          path="/industries-we-serve"
          element={<IndustriesWeServe />}
        />
        <Route
          path="/iso-certification-services"
          element={<IsoCertificationServices />}
        />
        <Route path="/food-safety-services" element={<FoodSafetyServices />} />
        <Route
          path="/sustainability-esg-services"
          element={<SustainabilityEsgServices />}
        />
        <Route
          path="/textile-compliance-services"
          element={<TextileComplianceServices />}
        />
        <Route
          path="/supply-chain-certification-services"
          element={<SupplyChainCertificationServices />}
        />
        {/* One route per Services dropdown item. Generated from CATEGORY_ORDER
            so the routes, the dropdown and the data cannot fall out of step —
            adding a category adds its page automatically. */}
        {CATEGORY_ORDER.map((category) => (
          <Route
            key={category}
            path={`/services/${categoryToId(category)}`}
            element={<ServiceCategoryPage category={category} />}
          />
        ))}
        {/* Cloud Security and Cyber Security were folded into Information
            Security, so their pages no longer generate. Redirect rather than
            404 anyone holding one of those links. */}
        <Route
          path="/services/cloud-security"
          element={<Navigate to="/services/information-security" replace />}
        />
        <Route
          path="/services/cyber-security"
          element={<Navigate to="/services/information-security" replace />}
        />

        <Route path="/services" element={<Services />} />
        <Route
          path="/iso-lead-auditor-training"
          element={<IsoLeadAuditorTraining />}
        />
        <Route
          path="/iso-lead-auditor-training/:slug"
          element={<IsoLeadAuditorDetail />}
        />
        <Route path="/faq" element={<Faq />} />
        <Route path="/:name" element={<ServicePage2 />} />
        <Route path="/home" element={<Navigate replace to="/" />} />
        <Route path="/training-registration" element={<RegisterForm />} />
        <Route path="/pecb/:itemName" element={<Pecb />} />
        <Route path="/team" element={<Team />} />
        <Route path="/our-team" element={<Team />} />
        <Route path="/training" element={<Trainings />} />
        <Route path="/highfield-training" element={<HighfieldTraining />} />
        <Route path="/haccp-training" element={<HaccpTraining />} />
        <Route path="/pecb-training" element={<PecbTraining />} />
        <Route path="/corporate-training" element={<CorporateTraining />} />
        <Route
          path="/iosh-managing-safely-training"
          element={<IoshManagingSafelyTraining />}
        />
        <Route path="/safety-training" element={<SafetyTraining />} />
        <Route path="/tracking" element={<Tracking />} />
        <Route path="/blog" element={withSuspense(<Blog />)} />
        <Route
          path="/blog/category/:categorySlug"
          element={withSuspense(<BlogCategoryPage />)}
        />
        <Route path="/blog/:specificBlogId" element={withSuspense(<BlogPostRoute />)} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/jobs" element={<Jobs />} />
        <Route path="/training-details" element={<TrainingDetails />} />
        <Route
          path={`/service/${cookies.clickedServiceId}`}
          element={<Auditing />}
        />
        <Route path="/Skill_Building" element={<SkillBuilding />} />
        <Route path="/Certifications" element={<Certification />} />
        <Route path="/updateclient" element={<UpdateClient />} />
        <Route path="/clientele" element={<Clientele />} />
        <Route path="/terms" element={<TermsAndConditions />} />

      </Routes>
    </>
  );
}

export default App;
